import _ from 'lodash';
import MatomoSearchMessage from '@/matomo/message/MatomoSearchMessage';

export default class MatomoSearch {
  private static query = '';
  private static resultCount = 0;

  public static updateSearchEvent(query: string, resultCount: number) {
    this.query = query;
    this.resultCount = resultCount;
    this.publishSearchDebounced();
  }

  public static trackSearchResultInteractionAsSearchEvent() {
    this.publishSearch();
  }

  private static publishSearchDebounced = _.debounce(MatomoSearch.publishSearch, 2000);

  private static publishSearch() {
    MatomoSearchMessage.from(this.query, this.resultCount).publish();
  }
}
